import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { getLabel } from '@/helpers/Utils';

export const fetchWorkFlowAssignType = createAsyncThunk(
  'workFlowAssignType/fetchWorkFlowAssignType',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetWorkFlowAssignTypes();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: getLabel(item.nameAr, item.nameEn),
          value: item.id,
          isGroup: item.isGroup,
          isEmployee: item.isEmployee,
          isRequester: item.isRequester,
          isManager: item.isManager,
        })) ?? [];
      return [...mappedData];
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  workFlowAssignTypeList: [],
  loading: false,
  error: '',
};

const workFlowAssignTypeSlice = createSlice({
  name: 'workFlowAssignType',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkFlowAssignType.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWorkFlowAssignType.fulfilled, (state, action) => {
        state.loading = false;
        state.workFlowAssignTypeList = action.payload;
        state.error = '';
      })
      .addCase(fetchWorkFlowAssignType.rejected, (state, action) => {
        state.loading = false;
        state.workFlowStagesList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default workFlowAssignTypeSlice.reducer;
